<template>
  <div class="tbe-read-more">
    <span v-html="formattedString" />
    <a :href="link" v-show="showReadMore" @click="triggerReadMore">{{ !isReadMore ? moreLabel : lessLabel }}</a>
  </div>
</template>

<script>
export default {
  name: "tbeReadMore",

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    moreLabel: {
      type: String,
      default: "Read more"
    },
    lessLabel: {
      type: String,
      default: "Less more"
    },
    text: {
      type: String,
      required: true
    },
    link: {
      type: String,
      default: "#"
    },
    letterCount: {
      type: Number,
      default: 100
    },
    wordCount: Number
  },
  data() {
    return {
      isReadMore: this.modelValue
    };
  },
  computed: {
    showReadMore() {
      if (this.letterCount && !this.wordCount) return this.text.length > this.letterCount
      if (this.wordCount) {
        const words = this.text.split(' ');
        return words.length > this.wordCount
      }
      return false;
    },
    formattedString() {
      if (this.letterCount && !this.wordCount) {
        if (!this.isReadMore && this.text.length > this.letterCount) {
          return this.text.substring(0, this.letterCount) + "...";
        }
        return this.text;
      }

      if (this.wordCount) {
        const words = this.text.split(' ');
        if (!this.isReadMore && words.length > this.wordCount) {
          return words.slice(0, this.wordCount - 1).join(' ') + '...';
        }
        return this.text;
      }

      return this.text;
    }
  },
  methods: {
    triggerReadMore(e) {
      if (this.link === "#") e.preventDefault();
      this.isReadMore = !this.isReadMore;

      this.$emit('update:modelValue', this.isReadMore);
    }
  }
}
</script>

<style lang="scss" scoped>
.tbe-read-more {
  display: inline-block;

  a {
    display: inline-block;
    color: var(--rs-accent-color);
  }
}
</style>
